export default __webpack_public_path__ + "static/media/paymethods.3901384f.png";